import Layout from '@/layout';
var marketingRouter = {
  path: '/marketing',
  component: Layout,
  redirect: '/bonusCode',
  name: 'Marketing',
  meta: {
    title: '营销',
    icon: 'clipboard'
  },
  children: [{
    path: 'advertise',
    component: function component() {
      return import('@/views/marketing/advertise/index.vue');
    },
    name: 'Advertiser',
    meta: {
      title: '广告管理',
      icon: ''
    }
  }, {
    path: 'pageComponent',
    component: function component() {
      return import('@/views/marketing/page/index.vue');
    },
    name: 'PageComponent',
    meta: {
      title: '页面配置',
      icon: ''
    }
  }, {
    path: 'bonus/list',
    component: function component() {
      return import('@/views/marketing/bonus/index.vue');
    },
    name: 'BonusRecord',
    meta: {
      title: '福利记录',
      icon: ''
    }
  }, {
    path: 'bonusCode',
    component: function component() {
      return import('@/views/marketing/bonusCode/index.vue');
    },
    name: 'BonusCode',
    meta: {
      title: '红包码',
      icon: ''
    }
  }, {
    path: 'depositConfig',
    component: function component() {
      return import('@/views/marketing/depositConfig/index.vue');
    },
    name: 'DepositConfig',
    meta: {
      title: '充值配置',
      icon: ''
    }
  }, {
    path: 'depositPromotionConfig',
    component: function component() {
      return import('@/views/marketing/depositPromotionConfig/index.vue');
    },
    name: 'DepositPromotionConfig',
    meta: {
      title: '充值套餐',
      icon: ''
    }
  }, {
    path: 'checkInConfig',
    component: function component() {
      return import('@/views/marketing/checkInConfig/index.vue');
    },
    name: 'CheckInConfig',
    meta: {
      title: 'CheckIn配置',
      icon: ''
    }
  }, {
    path: 'checkIn/list',
    component: function component() {
      return import('@/views/marketing/checkIn/index.vue');
    },
    name: 'CheckIn',
    meta: {
      title: '用户CheckIn记录',
      icon: ''
    }
  }, {
    path: 'turntable/list',
    component: function component() {
      return import('@/views/marketing/turntable/index.vue');
    },
    name: 'Turntable',
    meta: {
      title: '用户转盘记录',
      icon: ''
    }
  }
  // {
  //   path: 'coupon',
  //   component: () => import('@/views/marketing/coupon.vue'),
  //   name: 'Coupon',
  //   meta: { title: '优惠券', icon: '' },
  //   children: [
  //     {
  //       path: 'template',
  //       component: () => import('@/views/marketing/coupon/couponTemplate/index'),
  //       name: 'couponTemplate',
  //       hidden: true,
  //       meta: { title: '优惠券模板', icon: '' }
  //     },
  //     {
  //       path: 'list/save/:id?',
  //       name: 'couponAdd',
  //       meta: {
  //         title: '优惠劵添加',
  //         noCache: true,
  //         activeMenu: `/marketing/coupon/list`
  //       },
  //       hidden: true,
  //       component: () => import('@/views/marketing/coupon/list/creatCoupon')
  //     },
  //     {
  //       path: 'list',
  //       component: () => import('@/views/marketing/coupon/list/index'),
  //       name: 'List',
  //       meta: { title: '优惠券列表', icon: '' }
  //     },
  //     {
  //       path: 'record',
  //       component: () => import('@/views/marketing/coupon/record/index'),
  //       name: 'Record',
  //       meta: { title: '领取记录', icon: '' }
  //     }
  //   ]
  // },
  // {
  //   path: 'integral',
  //   component: () => import('@/views/marketing/integral/index'),
  //   name: 'Integral',
  //   meta: { title: '积分', icon: '' },
  //   children: [
  //     {
  //       path: 'integralconfig',
  //       component: () => import('@/views/marketing/integral/config/index'),
  //       name: 'integralConfig',
  //       meta: { title: '积分配置', icon: '' }
  //     },
  //     {
  //       path: 'integrallog',
  //       component: () => import('@/views/marketing/integral/integralLog/index'),
  //       name: 'integralLog',
  //       meta: { title: '积分日志', icon: '' }
  //     }
  //   ]
  // },
  ]
};
export default marketingRouter;